module.exports = __webpack_public_path__ + "media/images/client-4-ea5ce6e051b7be2ab5aec24cd3dd6436.png";